import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
    height: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    zIndex: 2,
  },
  assesmentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    height: 'calc(100% - 140px)',
    width: 'calc(100% - 1px)',
    overflowY: 'hidden',
    backgroundColor: '#EDEDF6',
    borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderTop: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderRight: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderBottom: 'solid 1px rgba(44, 45, 62, 0.3)',
  },
  contextualHelpIcon: {
    zIndex: 100,
    width: '50px;'
  }
}));
